module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer",
    class: {
      'footer_three': _vm.$slots.secondColumn
    }
  }, [_vm._t("firstColumn"), _vm._t("secondColumn"), (_vm.isButton) ? _c('Button', {
    attrs: {
      "bordered": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleDescription')
      }
    }
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdf2b3fa","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/cardfooter/MentoringCardFooter.vue
// module id = be2506b3b0f3fa5121b0
// module chunks = 89